class ScheduleShareView {

    constructor(onShareFn, onDoShareFn) {
        this.shareBtn = $('.app-share-btn');
        this.shareBtn.click(onShareFn);
        this.shareModal = $('#share');
        this.shareLink = this.shareModal.find('.app-share-link');
        this.copyToClipboard = this.shareModal.find('.copy-to-clipboard');
        this.copyToClipboard.click(this.copyLinkToClipboard.bind(this));
        this.doneButton = this.shareModal.find('.app-btn-done');
        this.shareWithAdvistor = this.shareModal.find('#enrolmentadvisor');
        this.doneButton.click(onDoShareFn);
    }

    showShared() {
        this.link = plannerApplication.yourProfile.getUrl() + '?restore=' + plannerApplication.yourProfile.getShareGuid();
        this.shareLink.attr('placeholder', this.link).val(this.link);
        this.shareModal.modal('show');
        return this.link;
    }

    copyLinkToClipboard() {
        navigator.clipboard.writeText(this.link);
    }
}
